import React from 'react'
import Link from 'components/Link'
import { ROUTE_PATH } from 'modules/routes/constants/index.cjs'

/**
 * The content
 * @type {string}
 */
const TEXT = 'Need Help?'

function OrderActionsHelp () {
  return (
    <Link to={ROUTE_PATH.SUPPORT}>
      {TEXT}
    </Link>
  )
}

export default OrderActionsHelp
